import IForeignItem from "../responses/IForeignItem";
import Item from "./Item";

export default class OrderLine {
  constructor(
    public item: Item,
    public quantity: number,
    public unitCode: string,
    public deliveredQuantity: number | undefined,
    public foreignItemCode: string | undefined = undefined,
    public supplierItemCode: string | undefined = undefined,
    public unitName: string,
    public deliveredLot: string | undefined,
    public deliveredBestBefore: string | undefined,
    public deliveredExpiry: string | undefined,
    public foreignItem: IForeignItem | undefined = undefined,
  ) { }

  get isExactDelivered() {
    return this.deliveredQuantity === this.quantity;
  }
  get isMissing() {
    return this.deliveredQuantity === 0;
  }
  get isUnderdelivered() {
    return this.deliveredQuantityOrZero < this.quantity && this.deliveredQuantityOrZero > 0;
  }
  get isOverdelivered() {
    return this.deliveredQuantityOrZero > this.quantity;
  }

  get deliveredQuantityOrZero() {
    return this.deliveredQuantity ?? 0;
  }

  get trackStock() {
    return this.foreignItem?.trackStock ?? true;
  }
}
